<script setup lang="ts">
import { byPublishedDate } from '~/utils/crystallize/article'

const article = inject(diKeys.article)

const articles = useArticles()

const RELATED_ARTICLES_LIMIT = 3

const relatedArticles = computed<CrystallizeArticle[]>(() => {
  const theme = article?.value?.components?.theme ?? []

  const allArticles = (articles.data.value?.children ?? []).filter(a => a.id !== article?.value?.id && a.components?.published)

  const relatedArticles: (CrystallizeArticle & { matches: number })[] = []

  for (const article of allArticles) {
    if (relatedArticles.length === RELATED_ARTICLES_LIMIT) {
      break
    }

    const matchingThemes = article.components?.theme?.filter(
      t1 => theme.some(t2 => t2.key === t1.key),
    )

    if (matchingThemes?.length) {
      relatedArticles.push({
        ...article,
        matches: matchingThemes.length,
      })
    }
  }

  return [...relatedArticles].sort((a, b) => {
    if (a.matches > b.matches) {
      return -1
    }

    if (a.matches < b.matches) {
      return 1
    }

    return byPublishedDate(a, b)
  }).slice(0, RELATED_ARTICLES_LIMIT)
})
</script>

<template>
  <ContentGrid v-if="relatedArticles.length > 0" class="gap-xl w-full">
    <h4 class="title-m !font-light full-width-content text-center">
      Relaterte artikler
    </h4>

    <ul class="grid grid-cols-subgrid full-width-content gap-y-xl">
      <li v-for="(relatedArticle, i) in relatedArticles" :key="relatedArticle.id" class="grid grid-cols-subgrid col-span-full">
        <NettbutikkArticleRelatedArticle :article="relatedArticle" :dir="i % 2 === 0 ? 'ltr' : 'rtl'" />
      </li>
    </ul>
  </ContentGrid>
</template>
